import { render, staticRenderFns } from "./ApplyStatusTabs.vue?vue&type=template&id=627c80fc&scoped=true"
import script from "./ApplyStatusTabs.vue?vue&type=script&lang=js"
export * from "./ApplyStatusTabs.vue?vue&type=script&lang=js"
import style0 from "./ApplyStatusTabs.vue?vue&type=style&index=0&id=627c80fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c80fc",
  null
  
)

export default component.exports